import React, { useMemo } from "react";
import "./Downloads.css";

import pdfIcon from "../../../../assets/images/allsolutions/downloads/pdf.png";
import downloadIcon from "../../../../assets/images/allsolutions/downloads/download.png";
import { useTranslation } from "react-i18next";
import { useDownloadsDocuments } from "../../../../hooks/usePublicQueries";

const Downloads = () => {
  const { t, i18n } = useTranslation();
  const { data: allDocuments } = useDownloadsDocuments(i18n.language);

  const items = useMemo(
    () =>
      allDocuments
        .filter((d) => d.source === "solutions" && d.fileUrl)
        .map((d) => ({
          id: d.id,
          name: d.title || "Document",
          href: d.fileUrl,
        })),
    [allDocuments]
  );

  const hasItems = items.length > 0;

  const handleOpen = (href) => {
    if (!href) return;
    window.open(href, "_blank", "noopener,noreferrer");
  };

  return (
    <section className="downloads">
      <div className="downloads-container">
        <div className="downloads-tag">{t("sections.allSolutions.downloads.tag")}</div>

        <h1 className="downloads-title">{t("sections.allSolutions.downloads.title")}</h1>

        <p className="downloads-desc">
          {hasItems
            ? t("sections.allSolutions.downloads.descWithItems")
            : t("sections.allSolutions.downloads.descEmpty")}
        </p>

        <div className="downloads-list">
          {items.map((item, index) => (
            <button
              key={item.id}
              type="button"
              className={`downloads-item ${index === 0 ? "active" : ""}`}
              onClick={() => handleOpen(item.href)}
            >
              <div className="downloads-left">
                <img src={pdfIcon} alt="" aria-hidden />
                <span>{item.name}</span>
              </div>

              <div className="downloads-right" aria-hidden>
                <img src={downloadIcon} alt="" />
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Downloads;
